module.exports = __webpack_public_path__ + "img/part9.561b72af.png";